var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showButton
        ? _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-danger rounded-pill mt-4",
                attrs: {
                  type: "button",
                  disabled:
                    _vm.isFetchingSubscriptionDetails ||
                    _vm.billingMaintenanceFeatureFlagEnabled(
                      _vm.currentAppConfig
                    ),
                  "data-test-hook": "remove-apparatus-button"
                },
                on: {
                  click: function($event) {
                    return _vm.checkApparatusSubscription()
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-trash-alt colorOrange" }),
                _vm._v(" " + _vm._s(_vm.$t("xRemoveFromAccount")) + " ")
              ]
            )
          ])
        : _vm._e(),
      _c(
        "Modal",
        {
          attrs: {
            modalId:
              "removeApparatusFromHomePremiumActivePlan-" +
              _vm.apparatus.apparatusId,
            size: "modal-lg"
          }
        },
        [
          _c(
            "ModalHeader",
            {
              attrs: {
                title: _vm.$t("xRemoveFromAccount"),
                icon: "fas fa-exclamation-triangle colorOrange"
              }
            },
            [
              _c("div", { staticClass: "float-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-icon-button btn-icon-button--gray",
                    attrs: {
                      type: "button",
                      "data-test-hook":
                        "x-button-removeApparatusFromHomePremiumActivePlan"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeAllModals()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]
          ),
          _c("ModalBody", [
            _vm.isGenerator()
              ? _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("xRemoveGeneratorFromHomePlanBodyText")
                          ) +
                          " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "row mt-4" }, [
                    _c("div", { staticClass: "col" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("xRemoveGeneratorDowngradeBodyText")) +
                          " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "row mt-4 mb-2" }, [
                    _c("div", { staticClass: "col" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "xRemoveGeneratorFromHomePlanConfirmationBodyText"
                            )
                          ) +
                          " "
                      )
                    ])
                  ])
                ])
              : _vm.isTank()
              ? _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("xRemoveTankFromHomePlanBodyText")) +
                          " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "row mt-4" }, [
                    _c("div", { staticClass: "col" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("xRemoveTankDowngradeBodyText")) +
                          " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "row mt-4 mb-2" }, [
                    _c("div", { staticClass: "col" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "xRemoveTankFromHomePlanConfirmationBodyText"
                            )
                          ) +
                          " "
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ]),
          _c("ModalFooter", [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  "data-test-hook": "no-do-not-remove-generator-button"
                },
                on: {
                  click: function($event) {
                    return _vm.closeAllModals()
                  }
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isGenerator()
                        ? _vm.$t("xKeepGeneratorButtonText")
                        : _vm.isTank()
                        ? _vm.$t("xKeepTankButtonText")
                        : ""
                    ) +
                    " "
                )
              ]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  "data-test-hook": "yes-remove-generator-button",
                  disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                    _vm.currentAppConfig
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.removeApparatusFromSubAndRemoveApparatus()
                  }
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isGenerator()
                        ? _vm.$t("xRemoveGeneratorButtonText")
                        : _vm.isTank()
                        ? _vm.$t("xRemoveTankButtonText")
                        : ""
                    ) +
                    " "
                ),
                _vm.removing
                  ? _c("span", {
                      staticClass: "spinner-border spinner-border-sm"
                    })
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            modalId:
              "cancelSingleApparatusActivePlan-" + _vm.apparatus.apparatusId,
            size: "modal-lg"
          }
        },
        [
          _c(
            "ModalHeader",
            {
              attrs: {
                title: _vm.$t("xCancelPlan"),
                icon: "far fa-exclamation-triangle colorOrange"
              }
            },
            [
              _c("div", { staticClass: "float-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-icon-button btn-icon-button--gray",
                    attrs: {
                      type: "button",
                      "data-test-hook":
                        "x-button-cancelSingleApparatusActivePlan"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeAllModals()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]
          ),
          _c("ModalBody", [
            _c("div", { staticClass: "row" }, [
              _vm.isGenerator()
                ? _c("div", { staticClass: "col" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("xCancelSingleGeneratorPlanBodyText")) +
                        " "
                    )
                  ])
                : _vm._e(),
              _vm.isTank()
                ? _c("div", { staticClass: "col" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("xCancelSingleTankPlanBodyText")) +
                        " "
                    )
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("xNoPartialRefundsBodyText")) +
                    " " +
                    _vm._s(_vm.getSubscriptionRenewalDate()) +
                    ". "
                )
              ])
            ]),
            _c("div", { staticClass: "row mt-4 mb-2" }, [
              _c("div", { staticClass: "col" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("xCancelPlanConfirmationBodyText")) + " "
                )
              ])
            ])
          ]),
          _c("ModalFooter", [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  "data-test-hook": "no-do-not-cancel-plan-button"
                },
                on: {
                  click: function($event) {
                    return _vm.closeAllModals()
                  }
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("xKeepSingleApparatusPlanButtonText")) +
                    " "
                )
              ]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  "data-test-hook": "yes-cancel-plan-button",
                  disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                    _vm.currentAppConfig
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.cancelPlanAndRemoveApparatusWithActivePlanFromAccount()
                  }
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("xCancelSingleApparatusPlanButtonText")) +
                    " "
                ),
                _vm.removing
                  ? _c("span", {
                      staticClass: "spinner-border spinner-border-sm"
                    })
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id:
              "removeApparatusWithInactivePlanModal-" +
              _vm.apparatus.apparatusId,
            role: "dialog"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
            [
              _c(
                "div",
                { staticClass: "modal-content" },
                [
                  _c(
                    "ModalHeader",
                    {
                      attrs: {
                        title: _vm.$t("xRemoveFromAccount"),
                        icon: "far fa-exclamation-triangle colorOrange"
                      }
                    },
                    [
                      _c("div", { staticClass: "float-right" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-icon-button btn-icon-button--gray",
                            attrs: {
                              type: "button",
                              "data-test-hook":
                                "x-button-removeApparatusWithInactivePlanModal"
                            },
                            on: {
                              click: function($event) {
                                return _vm.closeAllModals()
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-times" })]
                        )
                      ])
                    ]
                  ),
                  _c("ModalBody", [
                    _vm.isGenerator()
                      ? _c("div", [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("xRemoveGeneratorLoseAccessBodyText")
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "row mt-4 mb-2" }, [
                            _c("div", { staticClass: "col" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "xRemoveGeneratorConfirmationBodyText"
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      : _vm.isTank()
                      ? _c("div", [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("xRemoveTankLoseAccessBodyText")
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "row mt-4 mb-2" }, [
                            _c("div", { staticClass: "col" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("xRemoveTankConfirmationBodyText")
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _c("ModalFooter", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: {
                          type: "button",
                          "data-test-hook": "no-do-not-remove-generator-button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeAllModals()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isGenerator()
                                ? _vm.$t("xKeepGeneratorButtonText")
                                : _vm.isTank()
                                ? _vm.$t("xKeepTankButtonText")
                                : ""
                            ) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "button",
                          "data-test-hook": "yes-remove-generator-button",
                          disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                            _vm.currentAppConfig
                          )
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeApparatusWithInactivePlanFromAccount()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isGenerator()
                                ? _vm.$t("xRemoveGeneratorButtonText")
                                : _vm.isTank()
                                ? _vm.$t("xRemoveTankButtonText")
                                : ""
                            ) +
                            " "
                        ),
                        _vm.removing
                          ? _c("span", {
                              staticClass: "spinner-border spinner-border-sm"
                            })
                          : _vm._e()
                      ]
                    )
                  ])
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: {
            modalId: "planOnMobilePlatform-" + _vm.apparatus.apparatusId,
            size: "modal-md"
          }
        },
        [
          _c(
            "ModalHeader",
            {
              attrs: {
                title: _vm.$t("xActionRequired"),
                icon: "far fa-exclamation-triangle colorOrange"
              }
            },
            [
              _c("div", { staticClass: "float-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-icon-button btn-icon-button--gray",
                    attrs: {
                      type: "button",
                      "data-test-hook": "x-button-planOnMobilePlatform"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeAllModals()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]
          ),
          _c("ModalBody", [
            _c("div", { staticClass: "row" }, [
              _vm.activePlanOnGoogle
                ? _c("div", { staticClass: "col" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("xRemoveProductFromGoogle")) + " "
                    )
                  ])
                : _vm.activePlanOnApple
                ? _c("div", { staticClass: "col" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("xRemoveProductFromApple")) + " "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c("ModalFooter", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  "data-test-hook": "no-do-not-remove-generator-button"
                },
                on: {
                  click: function($event) {
                    return _vm.closeAllModals()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }